import { ApiError } from "../../../utils/api.ts";
import type { EmployeeOption, EmployeeRow } from "./types.ts";

export function extractApiMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiError) return error.message;
  if (error instanceof Error && error.message.trim()) return error.message;
  return fallback;
}

export function unwrapApiData(payload: unknown): unknown {
  if (payload && typeof payload === "object" && "data" in payload) {
    return (payload as { data: unknown }).data;
  }
  return payload;
}

export function unwrapApiDataArray(payload: unknown): unknown[] {
  const data = unwrapApiData(payload);
  return Array.isArray(data) ? data : [];
}

export function toEmployeeOptions(rows: EmployeeRow[]): EmployeeOption[] {
  return rows.map((row) => {
    const name =
      row.empName ||
      [row.firstName, row.lastName].filter(Boolean).join(" ") ||
      String(row.employeeId ?? row.id);
    const type = row.employeeType?.trim();
    return {
      value: String(row.id),
      label: type ? `${name} (${type})` : name,
      employeeType: row.employeeType,
    };
  });
}

export function statusBadgeVariant(status?: string) {
  const normalized = String(status ?? "").toLowerCase();
  if (normalized === "approved") return "success";
  if (normalized === "rejected") return "danger";
  if (normalized === "pending" || normalized === "0") return "warning";
  return "neutral";
}

export function formatStatus(status?: string): string {
  const normalized = String(status ?? "").trim();
  if (!normalized) return "-";
  if (normalized === "0") return "Pending";
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

export function formatDisplayDate(value?: string): string {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
}

